import React from 'react';
import { useParams } from 'react-router-dom';
import InformeFinalForm from '../components/InformeFinalForm';

const InformeFinalPage = () => {
  const { protocoloGeneral } = useParams();

  return (
    <section className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">Cierre</span>
          <h2 className="page-title">Diagnóstico e informe final</h2>
          <p className="page-subtitle">
            Guarda primero las conclusiones del caso, luego descarga el informe autogenerado y finalmente registra la entrega con el archivo final.
          </p>
        </div>
        <img src="/logo-inta.png" alt="Logo INTA" className="page-header-logo" />
      </div>

      <InformeFinalForm caseId={protocoloGeneral || ''} />
    </section>
  );
};

export default InformeFinalPage;
